module.exports = __webpack_public_path__ + "img/9-2.2b9b8a1f.png";